import indexI18n from '../../constants/i18n';

export default (language, i18n) => ({ ...indexI18n[language], ...i18n[language] });
